import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Blog from "./pages/Blog";
import CategoryPage from "./pages/CategoryPage";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";

function App() {
  return (
    <Router>
      <div className="site-container">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/mental-health" element={<CategoryPage />} />
            <Route path="/life-tips" element={<CategoryPage />} />
            <Route path="/recipes" element={<CategoryPage />} />
            <Route path="/hobbies" element={<CategoryPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

// 404 Not Found component
function NotFound() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">404 - Page Not Found</h1>
      </div>
      <div className="page-body">
        <p>Sorry, the page you're looking for doesn't exist.</p>
        <p>
          <a href="/">Return to homepage</a>
        </p>
      </div>
    </div>
  );
}

export default App;
